import { render, staticRenderFns } from "./logList.vue?vue&type=template&id=3348f2fb&scoped=true"
import script from "./logList.vue?vue&type=script&lang=js"
export * from "./logList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3348f2fb",
  null
  
)

export default component.exports